import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

/**
 * --------------------------------------------------------------
 * import module store vuex
 * --------------------------------------------------------------
 */
import customer from "./customer.module";
import staff from "./staff.module";
import staffChat from "./staff.chat.module";
import general from "./general.module";
import typing from "./typing.module";
import draft from "./draftmessage.module";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    customer,
    staff,
    staffChat,
    general,
    typing,
    draft,
  },
  plugins: [
    createPersistedState({
      key: "rw:store",
      paths: ["draft"],
    }),
  ],
});
